import React from 'react';
// import styles from './StaffMember.module.scss';
import StaffMember from "../../Clinic/StaffMember/StaffMember";


class ChainStaffMember extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <StaffMember {...this.props}/>
            </>
        );
    }
}

export default ChainStaffMember;
